import React, {useContext, useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { getAllV2Sport, getAllV2Teams } from '../../api/index.js';
import { getUserProvider } from '../../actions/auth.js';
import { Select, Checkbox, CircularProgress, ListItemText, OutlinedInput } from '@mui/material';
import { TeamsContext } from './fetch/GetTeamsComponent.js';

export default function SelectTeam({ teams = [], name, selectedTeam , handleChange }) {

    console.log("Draw SelectTeam")

    return (
        <FormControl fullWidth>
            <InputLabel>Equipe</InputLabel>
            <Select
                name={name}
                label="Equipe"
                value={selectedTeam || ""}  // Assurez-vous que la valeur n'est jamais null
                onChange={handleChange}
            >
                {teams.sort((a, b) => a.name.localeCompare(b.name)).filter(team => team._id).map((team) => (
                    <MenuItem key={team._id} value={team._id}>
                        <ListItemText primary={team.name} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}